//import React from 'react';
import pathIcon from '../Assets/home/path.svg';
import bottom from '../Assets/home/secOnebottom.png';
import eclipse from '../Assets/home/ellipse-38.svg';
import eclipse2 from '../Assets/home/ellipse-37.svg';
import wheat from '../Assets/home/wheat@2x.png';
import preser1 from '../Assets/home/preser-bg-1@2x.png';
import preser2 from '../Assets/home/preser-bg-2@2x.png';
import preser3 from '../Assets/home/preser-bg-3@2x.png';
import sci from '../Assets/home/image-placeholder@2x.png';
import shape2 from '../Assets/home/ellipse-2.svg';
import seed from '../Assets/home/seeds@2x.png';
import seed1 from '../Assets/home/seeds-1@2x.png';
import seed2 from '../Assets/home/seeds-2@2x.png';
import seed3 from '../Assets/home/seeds-3@2x.png';
import dosa from '../Assets/home/dosaill1-1@2x.png';
import smoke from '../Assets/home/smock-1@2x.png';

import React, { useState, useEffect } from 'react';


const Home = () => {

const [mouseX, setMouseX] = useState(0);
const [mouseY, setMouseY] = useState(0);

useEffect(() => {
  const handleMouseMove = (e) => {
    setMouseX(e.clientX);
    setMouseY(e.clientY);
  };

  window.addEventListener('mousemove', handleMouseMove);

  return () => {
    window.removeEventListener('mousemove', handleMouseMove);
  };
}, []);

const calcTranslate = (x, y) => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const offsetX = (x - windowWidth / 2) / 50; // Adjust divisor for desired effect
  const offsetY = (y - windowHeight / 2) / 50;

  return { offsetX, offsetY };
};

const { offsetX, offsetY } = calcTranslate(mouseX, mouseY);

  return (
    <div>
      {/* Section One */}
      <section className='secOne  font-secondary uppercase font-black relative'>
  <div className="sectionOne min-h-screen bg-bg_sec_one bg-cover bg-no-repeat bg-center">
    <img className='w-full h-full absolute inset-0 z-0' src={pathIcon} alt="Background Path Icon" />
    {/* <div className='font-extrabold absolute top-1/2 left-8 transform -translate-y-1/2 lg:text-5xl md:text-4xl md:leading-relaxed sm:text-4xl sm:leading-relaxed text-left text-white opacity-70 tracking-wide'>
      "Bringing Authentic <br />
      <span className='text-[#AA7029]'>South Indian</span> Tradition to Your <br />
      Table with Aryaa's<span className='text-[#AA7029]'> Finest Mixes</span>"
    </div> */}
    <div className="absolute bottom-0 w-full overflow-hidden" style={{ height: '200px' }}>
      {/* <img className='min-w-full h-full object-cover object-bottom' src={bottom} alt="Bottom Image" /> */}
    </div>
  </div>
</section>


      {/* Section Two */}
      <section className='secTwo min-h-screen bg-[#576F35] relative'>
        {/* Part One */}
        <div className='secTwoPartOne h-[350px] md:h-[300px] lg:h-[400px] bg-white flex flex-col md:flex-row relative z-10'>
          <img className='absolute h-[80%] right-0 -bottom-1 ' src={eclipse} alt="Ellipse SVG" />
          <img 
  className="wheat h-[50%] bottom-0 absolute z-0 left-[-5%]" 
  src={wheat} 
  alt="Wheat Image" 
/>          <div className='relative z-20 p-5 md:p-10  lg:pt-[50px] '>
            <h1 className='sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl text-center leading-relaxed font-secondary font-bold mt-5 md:mt-0 lg:mb-1'>
              <span className=' uppercase md:text-3xl lg:text-4xl xl:text-5xl bg-[#A98449] px-3 py-2 md:px-4 md:py-3 lg:px-5 lg:py-3 rounded-[15px] text-white mb-5 block'>
                Bringing the Taste of Home to Your Table!
              </span>
              Experience Traditional South Indian Flavors With Aryaa Foods' Premium Mixes.
            </h1>
          </div>
          <div className='absolute bottom-[50px] md:bottom-[50px] lg:bottom-[75px] left-1/2 transform -translate-x-1/2 translate-y-1/2 flex justify-center'>
            <img className='sm:h-[70px] md:h-[70px] lg:h-[100px] xl:h-[120px] mx-2' src={preser1} alt="Preser 1" />
            <img className='sm:h-[70px] md:h-[70px] lg:h-[100px] xl:h-[120px] mx-2' src={preser2} alt="Preser 2" />
            <img className='sm:h-[70px] md:h-[70px] lg:h-[100px] xl:h-[120px] mx-2' src={preser3} alt="Preser 3" />
          </div>
        </div>

        {/* Part Two */}

        <div className='secTwoPartTwo flex flex-col lg:flex-row items-start lg:items-end justify-between p-8 lg:p-10 gap-8 text-white relative'>
          <img className='absolute h-[350px] -left-10 -bottom-3 md:h-[300px] lg:h-[350px] z-0' src={eclipse2} alt="Ellipse SVG" />
          <div className="relative lg:w-1/2 z-10">
            <h1 className="text-3xl lg:text-4xl text-black xl:text-5xl font-black uppercase leading-tight text-left mb-4 mt-8 lg:mt-12">
              What’s food without a <span className="text-[#AA7029]">little love</span> and a <span className="text-[#AA7029]">lot of goodness</span>?
            </h1>
            <p className="text-lg text-black text-left lg:text-xl xl:text-2xl font-bold ">
              We at Aryaa Foods make the best Dosa batter. Using the finest and best quality rice with NO added preservatives. You will never miss home with Aryaa Dosa batter.
            </p>
          </div>
          <div className="relative lg:w-1/2 flex flex-col gap-4 font-forth font-medium lg:max-w-[468px] z-10">
            <div className="bg-white bg-opacity-60 text-black p-4 rounded-lg ">
              <div className="flex items-start">
                <div className="bg-[#7A3145] h-10 w-10 flex items-center justify-center rounded-full text-white font-semibold font-secondary px-4">1</div>
                <p className="ml-4 text-lg text-left">Produces soft and smooth Dosas and Idlis without any artificial colors or preservatives​.</p>
              </div>
            </div>
            <div className="bg-white bg-opacity-60 text-black p-4 rounded-lg">
              <div className="flex items-start">
                <div className="bg-[#7A3145] h-10 w-10 flex items-center justify-center rounded-full text-white font-secondary font-semibold px-4">2</div>
                <p className="ml-4 text-lg text-left">Making it easier for customers to enjoy home-cooked meals without extensive preparation. Daily Fresh & Hygienic Quality Home​.</p>
              </div>
            </div>
            <div className="bg-white bg-opacity-60 text-black p-4 rounded-lg">
              <div className="flex items-start">
                <div className="bg-[#7A3145] h-10 w-10 flex items-center justify-center rounded-full text-white font-secondary font-semibold px-4">3</div>
                <p className="ml-4 text-lg text-left">Authentic taste and texture, ideal as an accompaniment to various Indian dishes​.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className='min-h-100vh'>

        <div className='min-h-[50vh] flex lg:flex-row flex-col py-10 items-center justify-center relative'>

          <div className="flex flex-1 flex-col items-start justify-start text-left mx-10 my-5">
            <h1 className="m-0 self-stretch lg:pl-[25px] text-left relative tracking-[-0.01em] leading-[42px] uppercase z-[10] sm:leading-[25px] md:leading-[34px] sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl">
              <p className="[margin-block-start:0] [margin-block-end:3px]">
                <span>A secure and safe <br /> environment </span>
                <span className="text-darkolivegreen">
                  <span className="font-medium">constructed</span>
                </span>
              </p>
              <p className="m-0 text-darkolivegreen">
                <span className="text-black">and </span>
                <span className="font-medium">cutting-edge <br /> technology</span>
              </p>
            </h1>
          </div>

          <div className='flex flex-1 md:pb-10 items-end justify-end relative '>
            <div className='flex items-end justify-end relative w-full'>
              <img className='absolute flex  sm:max-w-[200px] md:max-w-[250px] lg:max-w-[500px] xl:max-w-[600px]' src={shape2} />

              <img className='flex relative lg:pr-[10%] sm:max-w-[200px] md:max-w-[500px] lg:max-w-[450px] xl:max-w-[500px] ' src={sci} />

            </div>
          </div>
        </div>

        <div className='min-h-[50vh] bg-darkolivegreen flex lg:flex-row flex-col  items-center justify-center relative'>
          <div className='flex flex-1 max-w-[35%] z-0 relative '>
            <div className='flex items-center justify-center relative w-full'>
              <div className='absolute top-[50%] left-[50%] z-0 flex items-center justify-center'>
                <img className='absolute flex items-center justify-center sm:max-w-[350px] md:max-w-[450px] lg:max-w-[450px] xl:max-w-[700px] rotate-[-60deg]' src={seed}  />
                <img className='absolute left-[-10%]flex items-center justify-center sm:max-w-[350px] md:max-w-[450px] lg:max-w-[550px] xl:max-w-[700px] rotate-[60deg]' src={seed2} />
                <img className='absolute lg:left-[10%] flex items-center justify-center sm:max-w-[350px] md:max-w-[450px] lg:max-w-[450px] xl:max-w-[500px] rotate-[180deg]' src={seed3} />
                <img className='absolute flex items-center justify-center sm:max-w-[300px] md:max-w-[400px] lg:max-w-[350px] xl:max-w-[400px]' src={smoke}       style={{ transform: `translate(${offsetX}px, ${offsetY}px)` }}
 />
              </div>
              <img className='sm:max-w-[300px] md:max-w-[400px] lg:max-w-[350px] xl:max-w-[400px] flex items-center justify-center relative' src={dosa} alt="Dosa" />
            </div>
          </div>


          <div className="flex flex-1 flex-col items-start justify-start text-left mx-10 my-10">
            <h1 className="relative tracking-[-0.01em] leading-[64px] uppercase flex items-center opacity-[0.8] max-w-full z-[4] text-4xl xl:text-5xl mb-1">
              <span className="w-full">
                <span className='text-white'>{`who is `}</span>
                <span className="font-semibold text-accent">
                  Aryaa Foods
                </span>
              </span>
            </h1>
            <p className="self-stretch h-auto relative text-md lg:xl xl:text-2xl leading-[30px] font-normal font-inherit text-white flex items-left justify-left z-[5]">
              Aryaa Foods is a company known for producing high-quality South Indian food products, particularly Idli and Dosa batter, under the name Aryaa Grains Packaging LLC. Established in the UAE in 2011, Aryaa Foods has gained popularity due to its commitment to quality and freshness. The company specializes in instant wet mixes that eliminate the need for traditional preparation methods, making it easier for customers to enjoy authentic South Indian cuisine without the hassle of soaking, grinding, and fermenting ingredients.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Home;
